export default {
    // Function to check if any cookie in the parameter is present on the browser cookies
    // It receives a list of cookies as parameter (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the cookie is present or not (in other words, if the content should be visible or not)
    analyze(cookies) {
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var indexOfEqual = cookie.indexOf("=");
            var cookieName = cookie.substring(0, indexOfEqual);
            var cookieValues = cookie.substring(indexOfEqual + 1, cookie.length).split(",");

            for (var j = 0; j < cookieValues.length; j++) {
                if (this.getByName(cookieName).indexOf(cookieValues[j]) >= 0) {
                    return true;
                }
            }
        }

        return false;
    },

    // Function to check the result of the cookies hide.
    // It receives a list of cookies as parameter (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the content should be visible or not
    analyzeHide(cookiesToHide){
        return !this.analyze(cookiesToHide);
    },

    // Function to check the result of the cookies to show and cookies to hide. If there are both cookies to show and
    // cookies to hide present in the browser, then we assume we don't want to display the content, so returns false.
    // Both parameters it receives are lists of cookies (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the content should be visible or not
    analyzeShowAndHide(cookiesToShow, cookiesToHide) {
        var resultToShow = this.analyze(cookiesToShow);
        var resultToHide = this.analyze(cookiesToHide);

        if((resultToShow && resultToHide) || (!resultToShow && !resultToHide)){
            return false;
        } else {
            // In this case, one of them is true and the other is false. If:
            // * resultToShow is true and resultToHide is false, we show the content, so return true;
            // * resultToShow is false and resultToHide is true, we hide the content, so return false.
            // So basically, we return the value of resultToShow!
            return resultToShow;
        }
    },

    getByName(cookieName) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + cookieName + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
        return "";
    }
};



// WEBPACK FOOTER //
// ./src/js/utils/Cookie.js